import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {ApiClientConfig} from './api-client-config';
import {
  ListCyberSecurityScanResponse
} from "it/primatoo/openapi/api/sec/schemas/cybersecurity/ListCyberSecurityScanResponse";
import {ListVendorForMenuResponse} from "it/primatoo/openapi/api/sec/schemas/cybersecurity/ListVendorForMenuResponse";
import {ListProductForMenuResponse} from "it/primatoo/openapi/api/sec/schemas/cybersecurity/ListProductForMenuResponse";
import {ColumnWithLocalization} from "it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization";
import {AgGridLangMap} from "@pt/pt-models";
import {TranslateService} from "@ngx-translate/core";
import {ColumnType} from "it/primatoo/openapi/api/org/schemas/common/ColumnType";
import { HasCveRequest } from 'it/primatoo/openapi/api/sec/schemas/cybersecurity/HasCveRequest';
import { HasCveResponse } from 'it/primatoo/openapi/api/sec/schemas/cybersecurity/HasCveResponse';

@Injectable({
  providedIn: 'root'
})
export class CyberSecuritySecService {

  private readonly endpointSec: string;

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient,
    private translateService: TranslateService
  ) {
    this.endpointSec = this.config.endPoint + '/api/sec/v2/cyber-sec/';
  }

  /**
   *  Last update 01/12/2023 @Giovanni
   */
  public getCyberSecurityScanData(): Observable<ListCyberSecurityScanResponse> {
    const url = this.endpointSec + 'scans/';
    return this.httpClient.get<ListCyberSecurityScanResponse>(url);
  }

  public checkVendorAndProduct(request: HasCveRequest): Observable<HasCveResponse> {
    const url = this.endpointSec + `has-cve`;
    return this.httpClient.post<HasCveResponse>(url, request);
  }

  /**
   * Last update 01/12/2023 @Giovanni
   * @param vendorFilter
   * @param page
   */
  public getVendor(vendorFilter?: string, page = 1): Observable<ListVendorForMenuResponse> {
    let url = this.endpointSec + `search/vendors/`;
    if (vendorFilter && vendorFilter.length > 0) {
      url += `?vendor=${vendorFilter}&page=${page}`;
    } else {
      url += `?page=${page}`;
    }
    return this.httpClient.get<ListVendorForMenuResponse>(url);
  }


  /**
   * Last update 01/12/2023 @Giovanni
   * @param vendorUUID
   * @param productFilter
   * @param page
   */
  public getVendorProducts(vendorUUID: string, productFilter?: string, page = 1): Observable<ListProductForMenuResponse> {
    let url = this.endpointSec + `search/${vendorUUID}/products/`;
    if (productFilter && productFilter.length > 0) {
      url += `?product=${productFilter}&page=${page}`;
    } else {
      url += `?page=${page}`;
    }
    return this.httpClient.get<ListProductForMenuResponse>(url);
  }

  /**
   * In adm non è presente l'api
   */
  public findUserColumns(type?: 'system' | 'api'): Observable<ColumnWithLocalization[]> {
    const agGridLangMap = new AgGridLangMap(this.translateService.currentLang);
    const systemCols = [
      {
        type: 'DATE',
        column: 'startedAt',
        label: agGridLangMap.getOf('startedAt'),
        uiAvailable: true,
        uiUserShow: true,
      },
      {
        type: 'DATE',
        column: 'completedAt',
        label: agGridLangMap.getOf('completedAt'),
        uiAvailable: true,
        uiUserShow: true,
      },
      {
        type: 'NUMBER',
        column: 'applications',
        label: agGridLangMap.getOf('applications'),
        uiAvailable: true,
        uiUserShow: true,
      },
      {
        type: 'NUMBER',
        column: 'vulnerabilities',
        label: agGridLangMap.getOf('vulnerabilities'),
        uiAvailable: true,
        uiUserShow: true,
      },
      {
        type: 'TEXT',
        column: 'status',
        label: agGridLangMap.getOf('status'),
        uiAvailable: true,
        uiUserShow: true,
      }
    ] as ColumnWithLocalization[];
    switch (type) {
      case "system":
        return of(systemCols);
      case "api":
        return of([
          {
            type: ColumnType.TEXT,
            column: 'orgName',
            label: agGridLangMap.getOf('orgName'),
            uiAvailable: true,
            uiUserShow: true,
            operations: []
          },
          ...systemCols
        ]);
      default:
        return of([])
    }
  }

}
